export default "__VITE_ASSET__TBNR1lMY__"